const eventRegExp = /^on[A-Z]/;
const cache = {};
export function isEventProperty(property) {
    if (property in cache) {
        return cache[property];
    }
    const result = !!property.match(eventRegExp);
    cache[property] = result;
    return result;
}

//# sourceMappingURL=isEventProperty.js.map